<template>
    <div class="c-view">
        <InternalHeader>
            <div slot="title" class="c-internal-header__title">
                Subscription
            </div>
        </InternalHeader>
    </div>
</template>

<script>
export default {
    components: {
        InternalHeader: function () {
            return import("@/js/components/partials/header");
        },
    },
};
</script>
